import { type IconProps } from './icon';

const SPINNER_SIZE = 48;

type SpinnerProps = Omit<IconProps, 'size'>;

export const Spinner = ({ color = 'currentColor', ...props }: SpinnerProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={SPINNER_SIZE}
			height={SPINNER_SIZE}
			viewBox="0 0 48 48"
			fill="none"
			{...props}>
			<path d="M38 24C38 16.0471 31.9529 10 24 10V6C33.9411 6 42 14.0589 42 24H38Z" fill={color} />
			<path d="M24 38C31.9529 38 38 31.9529 38 24L42 24C42 33.9411 33.9411 42 24 42V38Z" fill={color} />
			<path d="M10 24C10 31.9529 16.0471 38 24 38V42C14.0589 42 6 33.9411 6 24H10Z" fill={color} />
		</svg>
	);
};
